var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"segment-row"},_vm._l((_vm.segments),function(segment,index){return _c('div',{key:index,staticClass:"segment-viz",style:(_vm.getSegmentationCss(segment)),attrs:{"id":`fe-${_vm.type}-${segment.id}`},on:{"mouseenter":function($event){_vm.setPreview({
        $event,
        description: {
          Name: segment.id,
          From: segment.start,
          To: segment.end,
          'B-factor': _vm.round(segment.flexibility[_vm.type], 2),
        },
      })},"mouseleave":function($event){return _vm.setPreview(null)}}},[_c('span',{staticClass:"toggle-button",class:{
        want: _vm.isLoopWanted(segment.id),
        remove: !_vm.isLoopWanted(segment.id),
      },on:{"click":function($event){_vm.toggleLoopWanted(_vm.getLoop(segment))}}}),_c('span',{staticClass:"censor"},[_vm._v(" "+_vm._s(segment.id)+" ")])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }